import { chakra, defineRecipe } from '@plurall/elo-v3';

const headerRowRecipe = defineRecipe({
  className: 'media-card__header-row',
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 'space.8',
  },
});

const scoreRowRecipe = defineRecipe({
  className: 'media-card__score-row',
  base: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 'space.4',
  },
});

const scoreRecipe = defineRecipe({
  className: 'media-card__score',
  base: {
    margin: 0,
    fontSize: 'font.size.4xlarge',
    fontWeight: 'font.weight.regular',
    lineHeight: '125%',
    color: 'text.primary',
  },
});

const scoreUnitRecipe = defineRecipe({
  className: 'media-card__score-unit',
  base: {
    fontSize: 'font.size.xlarge',
    fontWeight: 'font.weight.semi.bold',
    lineHeight: '138%',
    verticalAlign: 'middle',
    color: 'text.tertiary',
  },
});

const titleRecipe = defineRecipe({
  className: 'media-card__title',
  base: {
    margin: 0,
    marginTop: 'space.12',
    fontSize: 'font.size.medium',
    fontWeight: 'font.weight.semi.bold',
    lineHeight: '150%',
    color: 'text.secondary',
  },
});

const footerRowRecipe = defineRecipe({
  className: 'media-card__footer-row',
  base: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 'space.8',
  },
});

const categoriaRecipe = defineRecipe({
  className: 'media-card__categoria',
  base: {
    margin: 0,
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.regular',
    lineHeight: '150%',
    color: 'text.tertiary',
  },
});

const descricaoRecipe = defineRecipe({
  className: 'media-card__descricao',
  base: {
    margin: 0,
    fontSize: 'font.size.xsmall',
    fontWeight: 'font.weight.regular',
    lineHeight: '150%',
    color: 'text.tertiary',
  },
});

const iconBoxRecipe = defineRecipe({
  className: 'media-card__icon-box',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: '40px',
    height: '40px',
    borderRadius: 'border.radius.xsmall',
  },
});

const emptyStateRecipe = defineRecipe({
  className: 'media-card__empty-state',
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'gap.3xsmall',
    padding: 'padding.large',
    minHeight: '112px',
    textAlign: 'center',
  },
});

const emptyStateTitleRecipe = defineRecipe({
  className: 'media-card__empty-state-title',
  base: {
    margin: 0,
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.semi.bold',
    lineHeight: '150%',
    color: 'text.secondary',
  },
});

export const MediaCardHeaderRowFactory = chakra('div', headerRowRecipe);
export const MediaCardScoreRowFactory = chakra('div', scoreRowRecipe);
export const MediaCardScoreFactory = chakra('p', scoreRecipe);
export const MediaCardScoreUnitFactory = chakra('span', scoreUnitRecipe);
export const MediaCardTitleFactory = chakra('h3', titleRecipe);
export const MediaCardFooterRowFactory = chakra('div', footerRowRecipe);
export const MediaCardCategoriaFactory = chakra('p', categoriaRecipe);
export const MediaCardDescricaoFactory = chakra('p', descricaoRecipe);
export const MediaCardIconBoxFactory = chakra('div', iconBoxRecipe);
export const MediaCardEmptyStateFactory = chakra('div', emptyStateRecipe);
export const MediaCardEmptyStateTitleFactory = chakra('h3', emptyStateTitleRecipe);
